import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Stack,
  Button,
  Menu,
  MenuItem,
} from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import MenuIcon from "@mui/icons-material/Menu";
import { useState, useEffect } from "react";
import { Container } from "@mui/material";
import { Actividades } from "../Actividad/Actividades";
import { Publicadas } from "../Actividad/Publicadas";
import { Pdtesvalidar } from "../Actividad/Pdtesvalidar";
import { Route, Routes, Link } from "react-router-dom";
import SignIn from "../Login/SignIn";
import { useNavigate } from "react-router-dom";
import { isEmpty, userIsAdmin, userPuedeReservarAulas } from "../../util/Functions";
import ActividadForm from "../Actividad/ActividadForm";
import { REV_PROXY_URL } from "../../util/Constants";
import { getUserLoggedLS, setUserLoggedLS } from "../../util/LocalStorageUtils";
import ProfessorDashboard from "../Guardias/ProfessorDashboard";
import AdminGuardiasDashboard from "../Guardias/AdminGuardiasDashboard";
import AulasLibres from "../Aulas/AulasLibres";
import ReservaAulas from "../Aulas/ReservaAulas";
import Perfil from "../Perfil/Perfil";

export default function MiNavBar() {
  const navigate = useNavigate();
  const [userLogged, setUserLogged] = useState(null);
  const [titulo, setTitulo] = useState("Activs. validadas");

  useEffect(() => {
    const uslog = getUserLoggedLS();
    if (!isEmpty(uslog)) {
      setUserLogged(uslog);
    }
  }, []);

  useEffect(() => {
    setUserLoggedLS(userLogged);
  }, [userLogged]);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleMenuOpciones = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    setUserLogged(null);
    navigate("/signin/");
  };

  const renderMenu = () => {
    if (!isEmpty(userLogged)) {
      return (
        <>
          <Stack direction="row" spacing={2}>
            <Button
              color="inherit"
              id="opciones-button"
              onClick={handleMenuOpciones}
              endIcon={<MenuIcon />}
              aria-controls="{open ? 'opciones-menu' : undefined}"
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              MENU
            </Button>
          </Stack>

          <Menu
            id="opciones-menu"
            anchorEl={anchorEl}
            open={open}
            MenuListProps={{ "aria-labelledby": "opciones-button" }}
            onClose={handleClose}
            onClick={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <Link to="/misactividades/" style={{ textDecoration: "none" }}>
              <MenuItem onClick={() => setTitulo("Mis actividades")}>
                Mis actividades
              </MenuItem>
            </Link>

            <Link to="/publicadas/" style={{ textDecoration: "none" }}>
              <MenuItem onClick={() => setTitulo("Activs. validadas")}>
                Validadas
              </MenuItem>
            </Link>

            <Link to="/guardias/" style={{ textDecoration: "none" }}>
              <MenuItem onClick={() => setTitulo("Guardias")}>
                Guardias
              </MenuItem>
            </Link>   

            {!isEmpty(userLogged) ? (
              <Link to="/perfil/" style={{ textDecoration: "none" }}>
                <MenuItem onClick={() => setTitulo("Mi perfil")}>
                  Mi perfil
                </MenuItem>
              </Link>
            ) : (
              ""
            )}

            {userPuedeReservarAulas(userLogged) ? (
              <Link to="/reservar-aulas/" style={{ textDecoration: "none" }}>
                <MenuItem onClick={() => setTitulo("Reservar aulas")}>
                  Reservar aulas
                </MenuItem>
              </Link>
            ) : (
              ""
            )}

            {userIsAdmin(userLogged) ? (
              <>
                <Link to="/guardias-admin/" style={{ textDecoration: "none" }}>
                  <MenuItem onClick={() => setTitulo("Guardias Admin")}>
                    Guardias Admin
                  </MenuItem>
                </Link>

                <Link to="/aulas-libres/" style={{ textDecoration: "none" }}>
                  <MenuItem onClick={() => setTitulo("Aulas Libres")}>
                    Aulas Libres
                  </MenuItem>
                </Link>

                <Link to="/pdtesvalidar/" style={{ textDecoration: "none" }}>
                  <MenuItem onClick={() => setTitulo("Pdtes. validar")}>
                    Pdtes. validar
                  </MenuItem>
                </Link>           
              </>
            ) : (
              ""
            )}

            <MenuItem onClick={handleLogout}>Cerrar sesión</MenuItem>
          </Menu>
        </>
      );
    } else {
      return (
        <>
          <Stack direction="row" spacing={2}>
            <Link to="/publicadas/" style={{ textDecoration: "none", color: "white" }}>
              <Button color="inherit">PUBLICADAS</Button>
            </Link>

            <Link to="/signin/" style={{ textDecoration: "none", color: "white" }}>
              <Button color="inherit" endIcon={<LoginIcon />}>
                LOGIN
              </Button>
            </Link>
          </Stack>
        </>
      );
    }
  };

  return (
    <>
      <AppBar position="sticky">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="logo"
          >
            <img
              src={REV_PROXY_URL + "logo-fondo-transp.png"}
              width="32"
              height="32"
              alt="Bulb"
            />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {titulo}
          </Typography>
          {renderMenu()}
        </Toolbar>
      </AppBar>
      <Container
        maxWidth={false}
        // maxWidth="xl"
        sx={{
          maxWidth: "100%",
          //border: 2,
          boxShadow: 1,          
          pb: 1,
          pl:1,
          pr:1,
        }}
      >
        <Routes>
          <Route
            path="/misactividades/"
            element={<Actividades setTitulo={setTitulo} />}
          />
          <Route
            path="/publicadas/"
            element={<Publicadas setTitulo={setTitulo} />}
          />

          <Route
            path="/pdtesvalidar/"
            element={<Pdtesvalidar setTitulo={setTitulo} />}
          />

          <Route
            path="/guardias/"
            element={<ProfessorDashboard setTitulo={setTitulo} profesorId={userLogged?.usuarioMobEnt?.id} />}
          />

          <Route
            path="/guardias-admin/"
            element={
              userIsAdmin(userLogged) ? (
                <AdminGuardiasDashboard setTitulo={setTitulo} />
              ) : (
                <div className="alert alert-danger m-3">
                  No tienes permisos para acceder a esta sección.
                </div>
              )
            }
          />

          <Route
            path="/perfil/"
            element={
              !isEmpty(userLogged) ? (
                <Perfil setTitulo={setTitulo} userLogged={userLogged} />
              ) : (
                <div className="alert alert-danger m-3">
                  No tienes permisos para acceder a esta sección.
                </div>
              )
            }
          />

          <Route
            path="/reservar-aulas/"
            element={
              userPuedeReservarAulas(userLogged) ? (
                <ReservaAulas setTitulo={setTitulo} userLogged={userLogged} />
              ) : (
                <div className="alert alert-danger m-3">
                  No tienes permisos para acceder a esta sección.
                </div>
              )
            }
          />

          <Route
            path="/aulas-libres/"
            element={
              userIsAdmin(userLogged) ? (
                <AulasLibres setTitulo={setTitulo} />
              ) : (
                <div className="alert alert-danger m-3">
                  No tienes permisos para acceder a esta sección.
                </div>
              )
            }
          />

          <Route
            path="/signin/"
            element={
              <SignIn
                userLogged={userLogged}
                setUserLogged={setUserLogged}
                setTitulo={setTitulo}
              />
            }
          />
          <Route path="/newactividad/" element={<ActividadForm />} />
          <Route exact path="/editactividad/:id" element={<ActividadForm />} />
          <Route path="/acex/" element={<Publicadas setTitulo={setTitulo} />} />
          <Route path="/" element={<Publicadas setTitulo={setTitulo} />} />
        </Routes>
      </Container>
    </>
  );
}
